<template>
  <div class="df fdc aic jcc">
    <h2 class="nexa-font-bold ttc">Reset Your Password</h2>

    <input v-model="password1" class="input-landing input1 mb20" type="password" placeholder="Password"/>
    <input v-model="password2" class="input-landing input1 mb20" type="password" placeholder="Re-enter password"/>
    <button class="button-landing nexa-font-bold ls05"
    :disabled="(disableSubmit && validatePassword) || changePasswordSuccess"
      v-on:click="resetPasswordComplete()">
      Change Password
    </button>

    <p v-if="$store.getters.authError" class="login-register-error animated fadeIn">{{ $store.getters.authError }}</p>

    <p v-if="$store.getters.afterEmailRecovery" class="login-register-error">If your e-mail address exists in the system, you will receive a password recovery message.</p>





    <!-- <p class="account-caption">Already have an account? <router-link :to="'/login'">Sign in</router-link></p> -->
    <!-- <p class="account-caption mt18">Don't have an account? <router-link :to="'/register'">Sign up</router-link></p> -->

  </div>
</template>

<script>
import router from '../../router'
export default {
  name: 'ResetPassword',
  data () {
    return {
      uid: '',
      email: '',
      password1: '',
      password2: '',
      disableSubmit: true,
      changePasswordSuccess: false
    }
  },
  props: ['landingEmail'],
  components: {

  },
  methods: {
    validatePassword () {
      if (this.password1.length < 6 || this.password1 !== this.password2) {
        return false
      }
      return true
    },
    validateEmail (mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return (true)
      }
      return (false)
    },
    setLandingEmail () {
      console.log('1 Forgot PW')
      this.$emit('setLandingEmail', {landingEmail: this.email})
    },
    resetPasswordComplete () {
      if (this.validatePassword()) {
        this.$store.dispatch('resetPasswordComplete', {
          code: this.$route.query.oobCode,
          newPassword: this.password1
        }).then(() => {
          this.changePasswordSuccess = true
          this.password1 = null
          this.password2 = null
        })
      } else {
        this.$store.dispatch('setAuthError', {
          message: 'The password must be at least 6 characters long. The passwords must match.'
        })
      }
    }
  },
  computed: {

  },
  watch: {
    password1() {
      if (this.validatePassword()) {
        this.disableSubmit = false
      } else {
        this.disableSubmit = true
      }
    },
    password2() {
      if (this.validatePassword()) {
        this.disableSubmit = false
      } else {
        this.disableSubmit = true
      }
    }
  },
  created () {
    this.landingEmail ? this.email = this.landingEmail : null
    // document.onkeydown = checkKey;
    var _this = this
    console.log('** Forgot Password Component Loaded', this.landingEmail, router.history.current, 'query', this.$route.query.oobCode)


    // this.$store.dispatch('clearAuthError', {})
    // function checkKey(e) {
    //   console.log('enter', e.keyCode == '13')
    //     e = e || window.event;
    //     if (e.keyCode == '13') {
    //       console.log('enter2')
    //       e.preventDefault()
    //       // _this.recover()
    //     }
    // }
  }
}
</script>

<style scoped lang="scss">
  h2 {
    color: black;
    font-weight: 500;
    margin-bottom: 30px;
    align-self: center;

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      font-size: 16px;
    }
  }


.account-caption {
  a {
    color: #5558FF;
    text-decoration: none;
    font-weight: 500;
    cursor: pointer;
  }
}
.mt18 {
  margin-top: 18px;
}
  button:disabled, button[disabled] {
  cursor: not-allowed !important;
    background-color: #aca1f4;
  }
</style>
